import React, { useState, useEffect } from 'react';
import { Badge, Dropdown, Container } from 'react-bootstrap';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FaEllipsisV } from 'react-icons/fa';

// Sample notification data
const notifications = [
    {
        id: 1,
        title: 'Upload Received',
        description: 'We’ve received your files! Your video editing project has officially begun.',
        duration: '2h',
        date: '2025-06-21',
        status: 'unread'
    },
    {
        id: 2,
        title: 'Editing Started',
        description: 'Our editors are now working on your project. Sit back and relax!',
        date: '2025-06-20',
        duration: '3h',
        status: 'unread'
    },
    {
        id: 3,
        title: 'Project Completed',
        description: 'Your edited video is ready! Tap here to review and download.',
        date: '2025-06-19',
        duration: '5h',
        status: 'unread'
    },
    {
        id: 4,
        title: 'New Package Alert',
        description: 'New! ‘Event Highlights Package’ now available – perfect for birthdays and holidays!',
        date: '2025-06-18',
        duration: '1h',
        status: 'read'
    },
    {
        id: 5,
        title: 'Missing Instructions',
        description: 'Almost there! Please provide your style preferences to help us edit your video just right.',
        date: '2025-06-18',
        duration: '1h',
        status: 'read'
    },
];

const Notifications = () => {
    const [notificationsState, setNotificationsState] = useState(notifications);

    // Mark notification as read
    const markAsRead = (id) => {
        setNotificationsState(notificationsState.map(notification =>
            notification.id === id ? { ...notification, status: 'read' } : notification
        ));
    };

    // Remove notification
    const removeNotification = (id) => {
        setNotificationsState(notificationsState.filter(notification => notification.id !== id));
    };

    return (
        <>
            <Header />
            <section className="page-section">
                <Container className="page-container">
                    <h4>Notifications</h4>
                    <ul className='notifications-list'>
                        {notificationsState.map((notification) => (
                            <li key={notification.id} className={notification.status === 'unread' ? 'notification-unread' : 'notification-read'}>
                                <div className='notifications-text'>
                                    <h5>{notification.title}</h5>
                                    <small>Date : {notification.date}</small>
                                    <p>{notification.description}</p>
                                    
                                </div>
                                <div className='notifications-duration'>
                                    
                                    {/* Triple Dot Menu for More Options */}
                                    <Dropdown align="end">
                                        <Dropdown.Toggle variant="link" id={`dropdown-${notification.id}`} size="sm">
                                            <FaEllipsisV />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item as="button" onClick={() => markAsRead(notification.id)}>
                                                Mark as Read
                                            </Dropdown.Item>
                                            <Dropdown.Item as="button" onClick={() => removeNotification(notification.id)}>
                                                Remove
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <span>{notification.duration}</span>
                                    {notification.status === 'unread' && (
                                        <Badge bg="warning">New</Badge>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                </Container>
            </section>
            <Footer />
        </>
    );
};

export default Notifications;
